import deephowApiServerWrapper from "@/server/api-server";
import axios from "axios";
import Vue from "vue";

export async function syncPrivatePlayerTrackingToServer({ trackingInfo }) {
  const payload = {
    ...trackingInfo,
    location: {},
  };
  const { ok, data, errorMessage } = await deephowApiServerWrapper("post", "/v1/tracking", payload);
  if (ok) {
    return { ok: true, data };
  } else {
    const customErrorMessage = `Failed to sync Private player tracking info to server - error: ${errorMessage}`;
    console.log(customErrorMessage);
    return { ok: false, errorMessage: customErrorMessage };
  }
}

export async function syncPublicPlayerTrackingToServer({ trackingInfo }) {
  try {
    const data = {
      doc: trackingInfo,
      workflowId: trackingInfo.workflowId,
    };
    const { status, statusText } = await axios({
      method: "post",
      url: Vue.prototype.$service.player + "tracking/public-videos",
      data,
    });
    const isSuccess = status === 200;
    if (isSuccess) {
      return { ok: true };
    }
    const error = `status: ${status}, statusText: ${statusText}`;
    throw error;
  } catch (error) {
    const errorMessage = `Failed to sync Public player tracking info to server -  error: ${error}`;
    console.log(errorMessage);
    return { ok: false, errorMessage };
  }
}
